// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___, * as ___CSS_LOADER_ICSS_IMPORT_0____NAMED___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../node_modules/@tcc/crate/src/StyleGuide/Colors/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emptyTableItem__container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: ${ ___CSS_LOADER_ICSS_IMPORT_0____NAMED___["ash"] };
  text-align: center;
  padding: 3rem 0;
}

.emptyTableItem__iconElem>svg {
  font-size: 2.5rem;
  color: ${ ___CSS_LOADER_ICSS_IMPORT_0____NAMED___["ash"] };
}
`, "",{"version":3,"sources":["webpack://./src/components/EmptyTableItem/emptyTableItem.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mDAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mDAAU;AACZ","sourcesContent":["@value ash from '@tcc/crate/src/StyleGuide/Colors/colors.css';\n\n.container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  color: ash;\n  text-align: center;\n  padding: 3rem 0;\n}\n\n.iconElem>svg {\n  font-size: 2.5rem;\n  color: ash;\n}\n"],"sourceRoot":""}]);
// Exports
export var ash = `${___CSS_LOADER_ICSS_IMPORT_0____NAMED___["ash"]}`;
export var container = `emptyTableItem__container`;
export var iconElem = `emptyTableItem__iconElem`;
export default ___CSS_LOADER_EXPORT___;
